var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoBlocoCampo01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1727",
    transform: "translate(241 571)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_43",
    cx: -225.6,
    cy: -564.2,
    rx: 14.6,
    ry: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1171",
    d: "M-222.1-540.3c-1-0.3-1.8-1.1-2-2.1c-0.5,0-0.9,0-1.4,0c-8.1,0-14.6-2.9-14.6-6.5v5 c0,3.6,6.5,6.5,14.6,6.5c1.1,0,2.2-0.1,3.4-0.2C-222.6-538.5-222.6-539.5-222.1-540.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1172",
    d: "M-225.1-544.1c0.5,0,0.9,0,1.4,0v-0.8c0-1.3,0.9-2.4,2.1-2.7c-0.3-0.5-0.4-1.1-0.4-1.8 c-1,0.1-2,0.1-3.1,0.1c-8.3,0-14.9-3-14.9-6.6v5.1C-240.1-547.1-233.4-544.1-225.1-544.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1173",
    d: "M-225.6-550.7c1.4,0,2.7-0.1,4.1-0.3l1.1-1.1c0.9-0.9,2.2-1,3.2-0.4c0.3-1.2,1.4-2,2.6-2h2 c0,0,0.1,0,0.1,0c0.8-0.7,1.3-1.7,1.3-2.7v-5c0,3.6-6.5,6.5-14.5,6.5c-8,0-14.5-2.9-14.5-6.5v5 C-240.1-553.6-233.6-550.7-225.6-550.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1728",
    transform: "translate(262.347 592.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1174",
    d: "M-226.6-564.4v-2l-2.4-0.4c-0.1-0.6-0.4-1.1-0.7-1.6l1.4-2l-1.4-1.4l-2,1.4c-0.5-0.3-1-0.5-1.6-0.7 l-0.4-2.4h-2l-0.4,2.4c-0.6,0.1-1.1,0.4-1.6,0.7l-2-1.4l-1.4,1.4l1.4,2c-0.3,0.5-0.5,1.1-0.7,1.6l-2.4,0.4v2l2.4,0.4 c0.1,0.6,0.4,1.1,0.7,1.6l-1.4,2l1.4,1.4l2-1.4c0.5,0.3,1.1,0.5,1.6,0.7l0.4,2.4h2l0.4-2.4c0.6-0.1,1.1-0.4,1.6-0.7l2,1.4l1.4-1.4 l-1.4-2c0.3-0.5,0.5-1,0.7-1.6L-226.6-564.4z M-234.8-562.5c-1.8,0-3.2-1.6-2.7-3.5c0.2-1,1.1-1.8,2.1-2.1c1.8-0.4,3.5,1,3.5,2.7 l0,0C-231.9-563.7-233.2-562.5-234.8-562.5L-234.8-562.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBlocoCampo01);
export default __webpack_public_path__ + "static/media/ico-bloco-campo-01.0b97c433ba07eb09e45e26d2daa424f4.svg";
export { ForwardRef as ReactComponent };